//* IMPORTACIONES LIBS
import store from '@/store'
import { getData } from '@core/utils/http/general'

// GET ORDEN FOR PERSONA-FK
export const RESUMEN_X_ORDEN = async orden => {
  // eslint-disable-next-line no-useless-catch
  try {
    const paramsRequest = {
      action: 6,
      orden,
      token: store.state.cuenta.session.token,
    }

    const response = await getData(paramsRequest, 'wscompras')

    if (response.status === 500) {
      throw new Error(response.data.message)
    }

    return response.data
  } catch (err) {
    throw err
  }
}

export const RESUMEN_X_TRAN = async transaccion => {
  // eslint-disable-next-line no-useless-catch
  try {
    const paramsRequest = {
      action: 52,
      transaccion,
      token: store.state.cuenta.session.token,
    }

    const response = await getData(paramsRequest, 'wscompras')

    if (response.status === 500) {
      throw new Error(response.data.message)
    }

    return response.data
  } catch (err) {
    throw err
  }
}
